import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  Overlay,
  Popover,
  Row,
  Tooltip,
} from "react-bootstrap";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";

import {
  fetchWorkLevelTypeData,
  selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import {
  fetchWorkLocationTypeData,
  selectLocationType,
  selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import {
  fetchDesignation,
  selectDesignation,
} from "../../redux/actions/designationAction";
import {
  fetchSalaryType,
  selectSalaryType,
} from "../../redux/actions/salaryTypeAction";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { useNavigate } from "react-router-dom";
import ExcelFile from "../../assets/Wok.xlsx";
import { fetchCompanySizeData } from "../../redux/actions/companySizeActions";
import { fetchAllOrgsData } from "../../redux/actions/getAllOrgsAction";
import { fetchCompanyData } from "../../redux/actions/getCompaniesAction";

const PostCard = () => {
  const navigate = useNavigate();
  // ...............................Post Job Start.......................................
  const sessionId = localStorage.getItem("sessionId");
  const UserType = localStorage.getItem("userType");
  const companyUId = localStorage.getItem("userUID");
  const [images, setImages] = useState([]);
  const [display, setDisplay] = useState(false);
  const [minimumSalary, setMinimumSalary] = useState("");
  const [maximumSalary, setMaximumSalary] = useState("");
  const [currency, setCurrency] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [requirement, setRequirement] = useState("");
  const [jobDescription, setjobDescription] = useState("");
  const [InsName, setInsName] = useState("");

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      compType: UserType,
      compUid: companyUId,
      cityId: cityListSearch,
      jbTypId: jobTypeSearch,
      workLevelType: workLevelSearch,
      workLocationType: workLocationSearch,
      designationId: designationSearch,
      salaryTypeId: salaryTypeSearch,
      minSalary: minimumSalary,
      maxSalary: maximumSalary,
      currency: currency,
      title: jobTitle,
      description: jobDescription,
      requirement: requirement,
    };
    console.log("body", body);

    if (
      cityListSearch === "" ||
      jobTypeSearch === "" ||
      workLevelSearch === "" ||
      workLocationSearch === "" ||
      designationSearch === "" ||
      salaryTypeSearch === "" ||
      minimumSalary === "" ||
      maximumSalary === "" ||
      requirement === "" ||
      currency === "" ||
      jobTitle === "" ||
      jobDescription === ""
    ) {
      toast.error("Please fill all the required fields");
    } else {
      try {
        const res = await axios.post("/Job/AddJob", body);
        console.log("gashgdjdgsa", res);
        toast.success(res.data.message);
        setSalaryTypeSearch();
        setDesignationSearch("");
        setworkLocationSearch("");
        setworkLevelSearch("");
        setjobTypeSearch("");
        setcityListSearch("");
        setMinimumSalary("");
        setMaximumSalary("");
        setJobTitle("");

        navigate("/ViewJobs");
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    }
  };
  // ...............................Post Job Start.......................................

  // ...............................Salary Dropdown.......................................

  const dispatch = useDispatch();

  // Fetch jobtype data on component mount
  const [salaryTypeSearch, setSalaryTypeSearch] = useState("");
  const { salaryTypeList, selectedSalaryTypeId } = useSelector(
    (state) => state.salaryType
  );

  useEffect(() => {
    dispatch(fetchSalaryType());
  }, [dispatch]);

  const handleSalaryType = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectSalaryType(selectedOption.value));
      setSalaryTypeSearch(selectedOption.value);
    }
  };
  // ...............................Salary Dropdown.......................................

  // ...............................Designation Dropdown.......................................
  const [designationSearch, setDesignationSearch] = useState("");

  const { designationList, selectedDesignationId } = useSelector(
    (state) => state.designation
  );
  // console.log('DESIGNATION',designationList,selectedDesignationId);

  useEffect(() => {
    dispatch(fetchDesignation());
  }, [dispatch]);

  const handleDesignation = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectDesignation(selectedOption.value));
      setDesignationSearch(selectedOption.value);
    }
  };
  // ...............................Designation Dropdown.......................................

  // ...............................Location Dropdown.......................................
  const [workLocationSearch, setworkLocationSearch] = useState("");

  const { workLocation, selectedCategoryId } = useSelector(
    (state) => state.workLocationType
  );
  useEffect(() => {
    dispatch(fetchWorkLocationTypeData());
  }, [dispatch]);

  const handleWorkLoc = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectWorkLocation(selectedOption.label));
      setworkLocationSearch(selectedOption.value);
    }
  };
  // ...............................Location Dropdown.......................................

  // ...............................Work Level Dropdown.......................................
  // Fetch work level data on component mount
  const [workLevelSearch, setworkLevelSearch] = useState("");
  const { workLevelList, selectedworkLevelId } = useSelector(
    (state) => state.workLevelType
  );
  // console.log('Work Level', workLevelList, selectedworkLevelId);

  useEffect(() => {
    dispatch(fetchWorkLevelTypeData());
  }, [dispatch]);

  const handleWorkLevel = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectWorkLevel(selectedOption.value));
      setworkLevelSearch(selectedOption.value);
    }
  };

  // ...............................Work Level Dropdown.......................................

  // ...............................Job Type Dropdown.......................................
  // Fetch jobtype data on component mount
  const [jobTypeSearch, setjobTypeSearch] = useState("");
  const { jobTypeList, selectedJobTypeId } = useSelector(
    (state) => state.jobType
  );

  useEffect(() => {
    dispatch(fetchJobType());
  }, [dispatch]);

  const handleJobType = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectJobType(selectedOption.value));
      setjobTypeSearch(selectedOption.value);
    }
  };
  // ...............................Job Type Dropdown.......................................

  // ...............................City Dropdown.......................................

  const [neworgType, setneworgType] = useState("");
  const [neworgId, setneworgId] = useState("");
  const [orgCity, setOrgCity] = useState(null);
  const [cityListSearch, setcityListSearch] = useState("");
  const { cityList, selectedcityId } = useSelector((state) => state.cities);

  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);

  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      setcityListSearch(selectedOption.value);
    }
  };
  const handleCitySelect1 = (selectedOption) => {
    if (selectedOption) {
      setOrgCity(selectedOption.value);
    }
  };

  const [fileName, setFileName] = useState("Wok.xlsx");
  const [selectedFile, setSelectedFile] = useState(null);

  const [showBulkModal, setShowBulkModal] = useState(false);
  const handleShowBulkModal = () => setShowBulkModal(true);
  const handleCloseBulkModal = () => {
    setShowBulkModal(false);
    setSelectedFile(null);
  };

  const downloadExcel = () => {
    const link = document.createElement("a");
    link.href = ExcelFile;
    link.download = fileName;
    link.click();
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setSelectedFile(file);
    }
  };

  const uploadFile = () => {
    if (!selectedFile) {
      alert("Please select a file to upload!");
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedFile);

    console.log("Uploading file:", selectedFile.name);
  };

  // ...............................City Dropdown.......................................

  // ...............................Organization Dropdown.......................................

  //   Get organization
  const [getallorgsId, setGetAllOrgsId] = useState("");
  const [orgType, setOrgType] = useState("");
  const { getallorgsList, selectedgetallId } = useSelector(
    (state) => state.getallorgs
  );
  useEffect(() => {
    dispatch(fetchAllOrgsData());
  }, [dispatch]);

  const handleOrganization = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectAllOrgs(selectedOption.value));
      setGetAllOrgsId(selectedOption.value);
      setOrgType(selectedOption.tagId);
    }
  };

  // ...............................Organization Dropdown.......................................

  // ...............................Company Category DDL.......................................
  // const [orgType, setOrgType] = useState("");
  const [companyListId, setCompanyListId] = useState("");
  const { getcompaniesList, selectedcompaniesId } = useSelector(
    (state) => state.getcompanies
  );

  useEffect(() => {
    dispatch(fetchCompanyData());
  }, [dispatch]);

  const handleSelectCompany = (selectedOption) => {
    console.log("selectedOption", selectedOption);

    if (selectedOption) {
      // dispatch(selectGetCompanies(selectedOption.value));
      setCompanyListId(selectedOption.value);
      setOrgType(selectedOption.tag);
    }
  };
  // const [getOrgInsTId, setGenOrgInstId] = useState(null);
  // ...............................Company Category DDL.......................................

  const [OrganizationName, setOrganizationName] = useState("");
  const [getOrgInsTId, setGenOrgInstId] = useState(null);
  const handleSaveInstitution = async () => {
    const formData = new FormData();
    formData.append("orgName", OrganizationName);
    formData.append("OrgType", "UnRegdGeneralOrg");
    formData.append("CityID", orgCity);
    formData.append("OrgLogo", fileName);
    formData.append("sessionId", sessionId);
    console.log("formData", formData);

    try {
      const res = await axios.post("/CandidateData/AddGnrlOrgData", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("res", res);
      // setGenOrgInstId(res.data.responseData);
      setneworgType(res.data.responseData.value);
      setneworgId(res.data.responseData.id);
      toast.success(res.data.message);
      setShowTooltip(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };

  // ...................file selecting...............

  // const [fileName, setFileName] = useState(""); // State to store selected filename
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      setFileName(file.name); // Set the filename in state
    }
  };
  // ...................toolTip...............
  const [showTooltip, setShowTooltip] = useState(false);
  const targetRef = useRef(null);

  const toggleTooltip = () => {
    console.log("Toggling Tooltip");
    setShowTooltip((prev) => !prev);
  };

  // ...............................company Dropdown.......................................

  return (
    <>
      <div className="main-container">
        <div className="content-wrapper">
          <div className="title delete-title d-flex justify-content-between align-items-center Title-header-Mobile
          post-new-job-title">
            <h1>
              <span className="orange-box"></span> Post a New Job
            </h1>
            <div className="bulk-upload-container">
              <Button
                className="mainBtn apply-job"
                onClick={handleShowBulkModal}
              >
                Bulk Jobs Upload{" "}
              </Button>
            </div>
          </div>

          <div className="card Alertcard PostCard">
            {/* ....................... 1 Row ......................... */}
            <div className="post-job-details-form p-0 ">
              <div className="post-form-row my-0 pt-3">
                <div className="post-form-group">
                  <label htmlFor="about">
                    Job Title <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Job title"
                    value={jobTitle}
                    onChange={(e) => setJobTitle(e.target.value)}
                  />
                  {display && !jobTitle ? (
                    <span className="error_msg_lbl">Enter Job Title</span>
                  ) : null}
                </div>

                <div className="post-form-group">
                  <label htmlFor="about">
                    Currency <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Type Curency"
                    value={currency}
                    onChange={(e) => setCurrency(e.target.value)}
                  />
                  {display && !currency ? (
                    <span className="error_msg_lbl">Enter Currency</span>
                  ) : null}
                </div>
              </div>
            </div>

            {/* ....................... 2 Row ......................... */}
            <div className="post-job-details-form p-0">
              <div className="post-form-row my-0">
                <div className="post-form-group">
                  <label htmlFor="about">
                    Minimum Salary <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Type Salary"
                    value={minimumSalary}
                    onChange={(e) => setMinimumSalary(e.target.value)}
                  />
                  {display && !minimumSalary ? (
                    <span className="error_msg_lbl">Enter Minimum Salary</span>
                  ) : null}
                </div>

                <div className="post-form-group">
                  <label htmlFor="about">
                    Maximum Salary <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Type Salary"
                    value={maximumSalary}
                    onChange={(e) => setMaximumSalary(e.target.value)}
                  />
                  {display && !maximumSalary ? (
                    <span className="error_msg_lbl">Enter Maximum Salary</span>
                  ) : null}
                </div>
              </div>

              {/* ....................... 3 Row ......................... */}

              <div className="post-form-row my-0">
                {/* ........Salary Type........ */}

                <div className="  post-form-group">
                  <label htmlFor="about">
                    Salary Type <span className="text-danger">*</span>
                  </label>
                  <ReactSelect
                    options={salaryTypeList}
                    onChange={handleSalaryType}
                    value={
                      salaryTypeList.find(
                        (option) => option.value === salaryTypeSearch
                      ) || null
                    }
                    placeholder="Select Location Type"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  // onInputChange={(inputValue) => setSalaryTypeSearch(inputValue)}
                  // invalid={display && salaryTypeSearch === ""}
                  />

                  {display && !salaryTypeSearch ? (
                    <span className="error_msg_lbl">Select Salary Type </span>
                  ) : null}
                </div>

                {/* ........Designation........ */}

                <div className="post-form-group">
                  <label htmlFor="externalUrl">Designation</label>
                  <ReactSelect
                    options={designationList}
                    onChange={handleDesignation}
                    value={
                      designationList.find(
                        (option) => option.value === designationSearch
                      ) || null
                    }
                    placeholder="Select Designation Type"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  // onInputChange={(inputValue) => setDesignationSearch(inputValue)}
                  // invalid={display && designationSearch === ""}
                  />
                  {display && !designationSearch ? (
                    <span className="error_msg_lbl text-red">
                      Enter Designation
                    </span>
                  ) : null}
                </div>
              </div>

              {/* ....................... 4 Row ........................ */}

              {/* ........Work level type........ */}

              <div className="post-form-row my-0">
                <div className="post-form-group">
                  <label htmlFor="about">
                    Work level type <span className="text-danger ms-2">*</span>
                  </label>
                  <ReactSelect
                    options={workLevelList}
                    onChange={handleWorkLevel}
                    value={
                      workLevelList.find(
                        (option) => option.value === workLevelSearch
                      ) || null
                    }
                    placeholder="Select Work Level"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  // onInputChange={(inputValue) => setworkLevelSearch(inputValue)}
                  // invalid={display && workLevelSearch === ""}
                  />
                  {display && !workLevelSearch ? (
                    <span className="error_msg_lbl">
                      Select Work location type{" "}
                    </span>
                  ) : null}
                </div>

                {/* ........Work location type........ */}

                <div className="post-form-group">
                  <label htmlFor="about">
                    Work location type{" "}
                    <span className="text-danger ms-2">*</span>
                  </label>

                  <ReactSelect
                    options={workLocation}
                    onChange={handleWorkLoc}
                    value={
                      workLocation.find(
                        (option) => option.value === workLocationSearch
                      ) || null
                    }
                    placeholder="Select Location Type"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  // onInputChange={(inputValue) => setworkLocationSearch(inputValue)}
                  // invalid={display && workLocationSearch === ""}
                  />
                  {display && !workLocationSearch ? (
                    <span className="error_msg_lbl">
                      Select Work location type{" "}
                    </span>
                  ) : null}
                </div>
              </div>

              {/* ....................... 5 Row ........................ */}
              <div className="post-form-row my-0">
                {/* ........ Job type........ */}
                <div className="post-form-group">
                  <label htmlFor="about">
                    Job type <span className="text-danger ms-2">*</span>
                  </label>

                  <ReactSelect
                    options={jobTypeList}
                    onChange={handleJobType}
                    value={
                      jobTypeList.find(
                        (option) => option.value === jobTypeSearch
                      ) || null
                    }
                    placeholder="Select JobType"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  // onInputChange={(inputValue) => setjobTypeSearch(inputValue)}
                  // invalid={display && cityListSearch === ""}
                  />
                  {display && !jobTypeSearch ? (
                    <span className="error_msg_lbl">Select Job type </span>
                  ) : null}
                </div>

                {/* ........ City ........ */}
                <div className=" post-form-group">
                  <label htmlFor="about">
                    City <span className="text-danger"> *</span>
                  </label>

                  <ReactSelect
                    options={cityList}
                    onChange={handleCitySelect}
                    value={
                      cityList.find(
                        (option) => option.value === cityListSearch
                      ) || null
                    }
                    placeholder="Select city"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />
                  {display && !cityListSearch ? (
                    <span className="error_msg_lbl">Select City </span>
                  ) : null}
                </div>
              </div>

              {UserType === "Company" ? (
                ""
              ) : (
                <>
                  <div className=" col-md-12 post-form-group">
                    <div controlId="institution">
                      <div className="mb-2 main-company-disabled">
                        <label htmlFor="about">
                          Company <span className="text-danger"> *</span>
                        </label>

                        {InsName !== "" ? (
                          <div>
                            <input
                              type="text"
                              value={InsName}
                              placeholder="Enter Org name"
                              className="mb-2 form-control"
                              disabled
                            />
                          </div>
                        ) : (
                          <div className="post-form-group mb-0">
                            <ReactSelect
                              options={getcompaniesList}
                              onChange={handleSelectCompany}
                              value={
                                getcompaniesList.find(
                                  (option) => option.value === companyListId
                                ) || null
                              }
                              placeholder="Select Company"
                              classNamePrefix="react-select"
                              className="form-control"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </div>
                      <a
                        href="#"
                        ref={targetRef}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleTooltip();
                        }}
                        className="createModal mt-2"
                      >
                        Create New
                      </a>
                      <Overlay
                        target={targetRef.current}
                        show={showTooltip}
                        placement="right"
                        rootClose
                        container={document.querySelector(".modal")}
                        onHide={() => setShowTooltip(false)} // Close when clicking outside
                      >
                        <Popover id="popover-basic">
                          <Popover.Header
                            as="h3"
                            className="Dark-Body-Card-group"
                          >
                            Create Organization
                          </Popover.Header>
                          <Popover.Body className="Dark-Body-Card-group">
                            <Form>
                              <div>
                                <label className="mb-1 Text-mb-Create">
                                  Org name
                                </label>
                                <input
                                  type="text"
                                  value={OrganizationName}
                                  onChange={(e) => {
                                    setOrganizationName(e.target.value);
                                    setInsName(e.target.value);
                                  }}
                                  placeholder="Enter Org name"
                                  className="mb-2 form-control Dark-Input-from-group"
                                />
                              </div>
                              <div>
                                <label className="mb-1 Text-mb-Create">
                                  City
                                </label>
                                <ReactSelect
                                  options={cityList}
                                  onChange={handleCitySelect1}
                                  value={
                                    cityList.find(
                                      (option) => option.value === orgCity
                                    ) || null
                                  }
                                  placeholder="Select City"
                                  classNamePrefix="react-select"
                                  className="form-control Dark-Input-from-group"
                                  styles={customStyles}
                                />
                              </div>
                              <div className=" mt-2 mb-2 Text-mb-Create">
                                <label className="mb-1">Org Logo</label>
                                <input
                                  type="file"
                                  id="lastName"
                                  className="form-control Dark-Input-from-group"
                                  placeholder=""
                                  onChange={handleFileChange}
                                //   onChange={(e) => {
                                //     handleProfileImageChange(e);
                                //   }}
                                //   invalid={displays && profileImage === ""}
                                />
                                {/* {displays && !profileImage ? (
                                <span className="error_msg_lbl text-red">
                                  Upload Image{" "}
                                </span>
                              ) : null} */}
                              </div>
                              <div className="d-flex justify-content-end">
                                <Button
                                  variant="primary"
                                  size="sm"
                                  onClick={handleSaveInstitution}
                                  className="me-2"
                                >
                                  Save
                                </Button>
                                <Button
                                  variant="secondary"
                                  size="sm"
                                  onClick={() => setShowTooltip(false)}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Form>
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="post-job-form">
              <div className="post-form-group">
                <label htmlFor="job-title" className="post-form-label mt-0">
                  Requirement<span>*</span>
                </label>

                <textarea
                  id="job-requirement"
                  className="post-description-input"
                  placeholder="Type the job requirement here..."
                  value={requirement}
                  onChange={(e) => setRequirement(e.target.value)}
                ></textarea>
                {display && !requirement ? (
                  <span className="error_msg_lbl">Enter requirement</span>
                ) : null}
              </div>
            </div>

            <div className="post-job-description py-0">
              <div className="post-form-group">

                <label htmlFor="job-description" className="post-form-label mt-0">
                  Job Description <span>*</span>
                </label>

                <textarea
                  id="job-description"
                  className="post-description-input"
                  placeholder="Type the job description here..."
                  value={jobDescription}
                  onChange={(e) => setjobDescription(e.target.value)}
                ></textarea>
                {display && !jobDescription ? (
                  <span className="error_msg_lbl">Enter Job Description</span>
                ) : null}
              </div>
            </div>

            <Button
              className="mainBtn apply-job mb-3 mt-2"
              onClick={(e) => handleSubmit(e)}
            >
              Submit
            </Button>
            {/* /*... 3  */}
          </div>
        </div>
      </div>

      <Modal
        show={showBulkModal}
        onHide={handleCloseBulkModal}
        size="md"
        centered
        className="Bulk-Upload-Excel-Modal"
      >
        <Modal.Header>
          <Modal.Title>Bulk Upload Excel File</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseBulkModal} />
        </Modal.Header>
        <Modal.Body>
          <div className="pt-3 ">
            <p className="text-center mb-2">Download Reference File Here</p>
            <div className="d-flex justify-content-center">
              <div className="col-md-6 ">
                <div
                  className="Excel-File-Box"
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    textAlign: "center",
                    backgroundColor: "#f9f9f9",
                    marginBottom: "15px",
                  }}
                >
                  <p style={{ margin: "0", fontWeight: "bold" }}>Wok.xlsx</p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="khoDwnlodBtn ms-3">
                  {/* <Tooltip title="Download reference file" arrow> */}
                  <p onClick={downloadExcel}>Download</p>
                  {/* </Tooltip> */}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <input
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileUpload}
                style={{
                  marginTop: "15px",
                  // border: "1px solid #ddd",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <div className="d-flex justify-content-end pe-3 pb-3">
          <div className="add-class-submit-button d-flex justify-content-center">
            {/* <Button variant="secondary" onClick={handleCloseBulkModal}>
                  Close
                </Button> */}
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" onClick={uploadFile}>
                Upload
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PostCard;
